import React from 'react';
import { connect } from "react-redux";

//Challeneges
import Otp from './OTP/Otp';
import Rsa from './RSA/Rsa';
import Verid from './Verid/Verid';
import { getDecisionApi } from './../../actions/crossSellApplicationActions';

class StepUpAuthentication extends React.Component {

    state ={
      challengeData: this.props.stepUpAuthenticationInfo !==null?this.props.stepUpAuthenticationInfo:null,
      veridQuestions: this.props.veridQuestions !==null?this.props.veridQuestions:{},
      bankInfo: this.props.bankInfo !==null?this.props.bankInfo:{}
    };

    componentDidMount(){
      let isReloadAction =this.state.challengeData == null;
      if(isReloadAction){
        this.props.getDecisionApi({ mover: this.props.history, nextPage: "" });
      }
    }

    componentDidUpdate(prevProps, nextState){
      if(prevProps.stepUpAuthenticationInfo !== this.props.stepUpAuthenticationInfo && this.props.stepUpAuthenticationInfo!==null ){
        this.setState({
          challengeData: this.props.stepUpAuthenticationInfo
        });
      }
    }

    componentDidUpdate(prevProps, nextState){
      if(prevProps.stepUpAuthenticationInfo !== this.props.stepUpAuthenticationInfo && this.props.stepUpAuthenticationInfo!==null ){
        this.setState({
          challengeData: this.props.stepUpAuthenticationInfo
        });
      } else if(prevProps.veridQuestions !== this.props.veridQuestions && this.props.veridQuestions!==null ){
        this.setState({
          veridQuestions: this.props.veridQuestions
        });
      } else if(prevProps.bankInfo !== this.props.bankInfo && this.props.bankInfo!==null ){
        this.setState({
          bankInfo: this.props.bankInfo
        });
      }
    }

    render = () => {
      const { challengeData, veridQuestions }=this.state;
      let selectedChallenege=null;

      if(challengeData && challengeData.challengeType !==null){
        switch (challengeData.challengeType) {
        case "OTP":
          selectedChallenege = <Otp challengeType={challengeData.status} bankInfo={this.state.bankInfo} verificationContextsId={challengeData.verificationContextsId} data={challengeData.communicationMethods} />;
          break;
        case "Rsa":
          selectedChallenege = <Rsa challengeType={challengeData.status} bankInfo={this.state.bankInfo} verificationContextsId={challengeData.verificationContextsId} data={challengeData.questions} />;
          break;
        case "VERID":
          let kbvType = challengeData.veridKbvResponses[1]&&challengeData.veridKbvResponses[1].knowledgeQuestionLevel;
          selectedChallenege = <Verid challengeType={challengeData.status} kbvType={kbvType} veridQuestions={veridQuestions} bankInfo={this.state.bankInfo} verificationContextsId={challengeData.verificationContextsId} />;
          break;
        default:
          selectedChallenege = <p className="decline-offer-desc auth-lock-statement">Something went wrong, please try again after 24 hours.</p>;
          break;
        }
      } else {
        selectedChallenege = <p className="decline-offer-desc auth-lock-statement">Something went wrong, please try again after 24 hours.</p>;
      }

      return (
        <div className="row">
          <div className="col-lg-12 col-xs-12">
            {selectedChallenege}
          </div>
        </div>
      );
    }

}

const mapStateToProps = (state) => {
  return {
    stepUpAuthenticationInfo: state.creditCardApplicant !==null?state.creditCardApplicant.decisionApiResponse:{},
    veridQuestions: state.creditCardApplicant !==null?state.creditCardApplicant.veridQuestions:{},
    bankInfo: state.creditCardApplicant !==null?state.creditCardApplicant.bankInfo:{}
  };
};

const mapDispatchToProps={
  getDecisionApi: getDecisionApi
};

export default connect(mapStateToProps, mapDispatchToProps)(StepUpAuthentication);
